var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.impersonation.id && _vm.$store.state.impersonation.email)?_c('impersonate'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }